module.exports = __webpack_public_path__ + "static/media/about-subHeader-Yellow.0d783444.png";